export default __webpack_public_path__ + "static/media/servicios_5.0b7d3b2b.jpg";